import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicSuggestedDelegatesService {
  removedDelegates: Set<string> = new Set();

  constructor() { }
}
